import { CollapsibleContainer } from "mt-components/CollapsibleContainer";

type CollapsibleFormContainerProps = { title: string };
export default function CollapsibleFormContainer({
  title,
  children,
}: React.PropsWithChildren<CollapsibleFormContainerProps>) {
  return (
    <CollapsibleContainer
      label={title}
      disableBorderBottom
      disableBorderTop
      summaryProps={{
        style: {
          gap: 0,
          height: 62,
        },
      }}
      arrowProps={{
        size: 24,
      }}
      labelRenderer={(label) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexGrow: 1,
          }}
        >
          <h4>{label}</h4>
          <span
            style={{
              flexGrow: 1,
              height: "1px",
              backgroundColor: "black",
              margin: "0 18px",
            }}
          />
        </div>
      )}
    >
      {children}
    </CollapsibleContainer>
  );
}
